import firebase from "firebase";
import React from "react";
import { connect } from "react-redux";
import {
    Button,
    Container,
    Dropdown,
    Icon,
    Menu,
    Message,
} from "semantic-ui-react";
import {
    createContext,
    emulatePlayer,
    filterContexts,
    refreshMessagingToken,
    revokeMessagingToken,
} from "./actions";
import ContextList from "./ContextList.js";
import isDm from "./selectors/isDm";
import isReallyDm from "./selectors/isReallyDm";
import STATUS from "./util/STATUS";

class App extends React.PureComponent {
    render() {
        const {
            isReallyDm,
            isDm,
            hasMessagingToken,
            getMessagingToken,
            clearMessagingToken,
            emulatePlayer,
            outOfDate,
            createContext,
            filterContexts,
            contextFilter,
        } = this.props;
        return (<div>
            <Menu inverted className="smash-to-top">
                <Container>
                    <Dropdown item text="The Economy">
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={hasMessagingToken
                                ? clearMessagingToken
                                : getMessagingToken
                            }>
                                {hasMessagingToken
                                    ? <Icon name="toggle on" color="green" />
                                    : <Icon name="toggle off" color="grey" />
                                }
                                Notifications
                            </Dropdown.Item>
                            {isReallyDm && <Dropdown.Item onClick={() =>
                                emulatePlayer(isDm)}
                            >
                                {isDm
                                    ? <Icon name="toggle off" color="grey" />
                                    : <Icon name="toggle on" color="green" />
                                }
                                Emulate Player
                            </Dropdown.Item>}
                            <Dropdown.Item onClick={() => firebase.logout()}>
                                <Icon name="log out" color="grey" />
                                Logout
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {isDm && <Dropdown item text="Filter">
                        <Dropdown.Menu>
                            {Object.keys(STATUS).map(k =>
                                <Dropdown.Item key={k}
                                               onClick={() => filterContexts(STATUS[k])}>
                                    <Icon name={contextFilter === STATUS[k] ? "check circle outline" : "circle outline"} color="grey" />
                                    {STATUS[k]}
                                </Dropdown.Item>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>}
                    {isDm && <Menu.Item onClick={() => createContext()}>
                        New Context
                    </Menu.Item>}
                </Container>
            </Menu>
            {outOfDate && <OutOfDate />}
            <Container>
                <ContextList isDm={isDm} />
            </Container>
        </div>);
    }
}

// trailing div is to maintain the bottom margin
const OutOfDate = () =>
    <Container>
        <Message info>
            <p>
                Newer Version Available
                {" "}
                <Button onClick={(e) => {
                    e.preventDefault();
                    window.location.reload();
                }}>
                    REFRESH
                </Button>
            </p>
        </Message>
        <div />
    </Container>;

// noinspection JSUnusedGlobalSymbols
export default connect(
    state => ({
        contextFilter: state.contextFilter,
        hasMessagingToken: !!state.messagingToken,
        isDm: isDm(state),
        isReallyDm: isReallyDm(state),
        outOfDate: state.outOfDate,
    }),
    dispatch => ({
        filterContexts: status => dispatch(filterContexts(status)),
        emulatePlayer: yesOrNo => dispatch(emulatePlayer(yesOrNo)),
        createContext: () => dispatch(createContext()),
        getMessagingToken: () => dispatch(refreshMessagingToken()),
        clearMessagingToken: () => dispatch(revokeMessagingToken()),
    }),
)(App);



// WEBPACK FOOTER //
// ./src/App.js